'use strict';

/**
 * Calculates the number of express button stencils to show for the given response
 * @param {Object} paymentMethodSetResponse - The payment method set response for the express component
 * @returns {number} The number of buttons, between 0 and 5
 */
function calculateCount(paymentMethodSetResponse) {
    // Calculate number of express payment methods
    var expressMethodCount = paymentMethodSetResponse.paymentMethodSet.paymentMethods.filter(function (method) {
        return method.paymentModes.includes('Express');
    }).length;

    // Limit by maximum button count, default 5
    var buttonCount = Math.min(expressMethodCount, paymentMethodSetResponse.expressMaximumButtonCount || 5);

    // Limit count to [0, 5]
    return Math.max(0, Math.min(buttonCount, 5));
}

/**
 * Renders express button stencils at the given element, for an express component using the given response.
 * @param {Object} element - The jQuery object for the element where the express component is mounted
 * @param {Object} paymentMethodSetResponse - The payment method set response for the express component
 */
function render(element, paymentMethodSetResponse) {
    element.addClass('salesforce-express-element-stencils-visible');

    // Create container element for stencil buttons
    var stencils = $('<div class="salesforce-express-stencils">');
    if (paymentMethodSetResponse.expressLayout === 'horizontal') {
        stencils.addClass('horizontal');
    }

    // Calculate stencil button height
    var height = Math.max(40, Math.min(paymentMethodSetResponse.expressButtonHeight || 40, 55));

    // Determine number of stencil buttons to show
    var count = calculateCount(paymentMethodSetResponse);
    for (var i = 0; i < count; i += 1) {
        stencils.append('<div style="height: ' + height + 'px">');
    }

    // Render the stencils
    element.append(stencils);

    element.on('sfp:paymentmethodsrendered', function () {
        // Remove them when the real buttons are rendered (if any)
        element.removeClass('salesforce-express-element-stencils-visible');
        stencils.remove();
    });
}

module.exports = {
    render: render
};
